import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=1f2c9616"
import script from "./DateInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports